import type { NextPage } from 'next'
import styled from 'styled-components'
import client from "../lib/graphql"

import ContentBlock from '../components/base/ContentBlock'
import ContentSlider from '../components/base/ContentSlider'

import TextBlock from '../components/base/TextBlock'
import Layout from '../components/layouts/Index'
import { GET_PRODUCT_CONTENT } from '../graphql/query'
import SEO from '../components/base/Seo'
// import Image from 'next/image'

const ProductDesign: NextPage<{ pageData: any, headerSlider: any }> = ( { pageData, headerSlider } ) => {
  
  return (
    <Layout heroSlider={headerSlider}>

      { pageData && <PageWrap id="content">

        <div  className={`section grid transition-all`}>
          <ContentBlock
            title={pageData.title ? pageData.title : ''}
            content={pageData.lead_text ? pageData.lead_text : ''}
            isPageTitle={true}
          />
        </div>

        

        { pageData.slider && <div className='section'>
          <ContentSlider 
            contents={pageData.slider} 
          />
        </div>}

        { pageData.content && <div className='section grid spacing'>
          <TextBlock contents={pageData.content} />
        </div> }


      </PageWrap> }

      { pageData && <SEO title={pageData.title} description={pageData.lead_text}  /> }
    </Layout>
  )
}

export default ProductDesign;

export async function getStaticProps() {


  const { data: { produkte } } = await client.query({
    query: GET_PRODUCT_CONTENT,
  });


  return {
    props: {
      pageData: produkte ? produkte.data.attributes : null
    },
    revalidate: 10,
 };
}

const PageWrap = styled.div`

`

